<template>
  <div>
    <wc-data-box title='Geolocation' titleIcon='mdi-map-marker' :loading='isLoading'>
      <template v-slot:toolbarButtons>
        <span
          v-if='(project && !project.lat && !project.lng) || (estimate && !estimate.lat && !estimate.lng)'
          class='caption mr-2 grey--text font-italic'
          style='letter-spacing: -0.4px !important;'
        >
          Geolocation has not been set
        </span>
        <v-btn small depressed color='primary' width='76px' @click='showGeolocator=!showGeolocator'>
          <v-icon x-small class='mr-1'>{{ showGeolocator ? 'mdi-arrow-expand-up' : 'mdi-arrow-expand-down' }}</v-icon>
          {{  showGeolocator ? 'Hide' : 'Show' }}
        </v-btn>
      </template>
      <div v-if='showGeolocator'>
        <v-card-text>
          <h3>Current Lat/Lng for Project:</h3>
          <br> Lat: {{ project ? project.lat : estimate.lat }}
          <br> Lng: {{ project ? project.lng : estimate.lng }}
        </v-card-text>
        <v-card-actions>
          <v-btn @click='trackGeoLocation' depressed color='info' small>
            <v-icon left>mdi-map-marker</v-icon>
            Start Tracking
          </v-btn>   
        </v-card-actions>
        <v-card-text>
          Your Lat: {{ lat }}<br>
          Your Lng: {{ lng }}<br>
          <small> Wait 5-10 seconds for the values to settle before clicking "Save Position" </small>
        </v-card-text>
        <v-card-actions>
          <v-btn @click='saveGeoLocation' depressed :disabled='!lat || !lng' color='success' small>
            <v-icon left>mdi-check</v-icon>
            Save Position
          </v-btn>
        </v-card-actions>
      </div>
    </wc-data-box>
  </div>
</template>

<script>

import _ from 'lodash'
import estimatesAPI from '@/modules/estimates/api/estimates'
import projectAPI from '@/modules/projects/api/projects'

export default {

  name: 'fc-geolocator',
  props: {
    project: {
      required: false
    },
    estimate: {
      required: false
    }
  },
  data: () => ({
    isLoading: false,
    showGeolocator: false,
    objCopy: {},
    lat: 0,
    lng: 0
  }),
  mounted() {
    if ((this.project && !this.project.lat && !this.project.lng) || (this.estimate && !this.estimate.lat && !this.estimate.lng)) {
      this.showGeolocator = true
    }
  },
  computed: {

  },
  methods: {
    trackGeoLocation () {
      if (!navigator.geolocation) {
        alert('You have not allowed location access on your browser')
      }
      else {
        navigator.geolocation.watchPosition(pos => {
          this.lat = pos.coords.latitude
          this.lng = pos.coords.longitude
        })
      }
    },
    saveGeoLocation () {
      if (this.lat !== 0 && this.lng !== 0) {
        this.objCopy = this.project ? _.cloneDeep(this.project) : _.cloneDeep(this.estimate)
        this.objCopy.lat = this.lat
        this.objCopy.lng = this.lng
        this.save()
      }
      if (!navigator.geolocation) {
        alert('You have not allowed location access on your browser')
      }
      else {
        navigator.geolocation.getCurrentPosition(pos => {
          this.lat = pos.coords.latitude
          this.lng = pos.coords.longitude
        })
      }
    },
    async save () {
      this.isLoading = true
      this.project ? await projectAPI.updateProject(this.objCopy) : await estimatesAPI.updateEstimate(this.objCopy)
      this.$emit('getUpdatedWO')
      this.isLoading = false
    },
  }
}
</script>